import {Model} from "@/models/Model";

export class Role extends Model {
    primaryKey = 'name';
    modelUri = 'role';
    fields = [
        'description'
    ];
}